import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { empresasApi } from '@/api/apiClient';
import { UsageDisplay } from '@/components/UsageDisplay';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function UsoPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['uso'],
    queryFn: () => empresasApi.uso(),
  });

  if (isLoading) {
    return (
      <div className="p-6 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <Card>
          <CardContent className="pt-6">
            <p className="text-destructive">Erro ao carregar uso: {error.message}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">Uso do plano</h1>
      <UsageDisplay
        usage={data?.uso}
        limits={data?.limites}
        storage_usado_mb={data?.storage_usado_mb}
        percentuais={data?.percentuais}
      />
    </div>
  );
}
